import React from 'react';
import { csrfToken } from '@rails/ujs';
import AlLogoIcon from '../../../../../assets/images/reskin-images/icon--al-logo.svg';
import ResourcesIcon from '../../../../../assets/images/reskin-images/icon--resources.svg';
import UserIcon from '../../../../../assets/images/reskin-images/icon--user.svg';
import LogOutIcon from '../../../../../assets/images/reskin-images/icon--log-out.svg';
import EventsIcon from '../../../../../assets/images/reskin-images/icon--events.svg';
import StarIcon from '../../../../../assets/images/reskin-images/icon--star2.svg';
import SupportIcon from '../../../../../assets/images/reskin-images/icon--support.svg';
import NotesIcon from '../../../../../assets/images/reskin-images/icon--note.svg';
import IconHeart from '../../../../../assets/images/reskin-images/icon--heart.svg';

import UsersCircleIcon from '../../../../../assets/images/reskin-images/icon--user-circle.svg';
import SmartPhoneIcon from '../../../../../assets/images/reskin-images/icon--smartphone-active.svg';
import ModulesIcon from '../../../../../assets/images/reskin-images/icon--modules.svg';
import BehaviorsIcon from '../../../../../assets/images/reskin-images/icon--behaviors.svg';
import SalesIcon from '../../../../../assets/images/reskin-images/icon--sales.svg';
import CopyIcon from '../../../../../assets/images/reskin-images/icon--copy.svg';
import Reports from '../../../../../assets/images/reskin-images/reports.svg';
import Cohorts from '../../../../../assets/images/reskin-images/cohorts.svg';
import Orders from '../../../../../assets/images/reskin-images/orders.svg';
import WebinarsIcon from '../../../../../assets/images/reskin-images/icon--webinars.svg';
import ToolIcon from '../../../../../assets/images/reskin-images/icon--tool.svg';
import AlexIcon from '../../../../../assets/images/chat-alex-icon-gradient.svg';

import SidebarHomeIcon from '../../../../../assets/icons/home.svg';
import SidebarFieldNotesIcon from '../../../../../assets/icons/field-notes-flag.svg';
import SidebarModulesIcon from '../../../../../assets/icons/star.svg';
import SidebarALEXIcon from '../../../../../assets/icons/chat-bubble.svg';
import SidebarH2HIcon from '../../../../../assets/icons/heart.svg';
import SidebarNotesIcon from '../../../../../assets/icons/notes.svg';
import SidebarEventsIcon from '../../../../../assets/icons/calendar.svg';
import SidebarResourcesIcon from '../../../../../assets/icons/open-book.svg';
import SidebarAdminIcon from '../../../../../assets/icons/wrench.svg';

import { FAQ1, FAQ2, FAQ3 } from '../../components/h2h/faq';
import { getAlexUrl } from '../getAlexUrl';

export const getSideBarMenuList = (
  isTenant,
  tenant,
  isSingleModule,
  isAlexAvailable
) => {
  const resources = [
    {
      path: '/v2/resources/playbook-direct',
      text: 'Playbook Direct',
      enabled: !tenant || tenant?.has_al_direct
    },
    {
      path: '/v2/resources/get-your-links',
      text: 'Get Podcast Links',
      enabled: true
    },
    {
      path: '/v2/resources/book-summaries',
      text: 'Book Summaries',
      enabled: !tenant || tenant?.has_book_summaries
    }
  ];

  const itemList = [
    {
      icon: SidebarHomeIcon,
      text: 'Dashboard',
      path: '/v2',
      onClick: () => {}
    },
    {
      icon: SidebarFieldNotesIcon,
      text: 'Field Notes',
      path: 'https://admiredleadership.com/field-notes-archives/',
      target: '_blank',
      onClick: () => {}
    },
    {
      icon: SidebarModulesIcon,
      text: isSingleModule ? 'Behaviors' : 'Modules',
      path: '/v2/program',
      onClick: () => {}
    }
  ];
  if (!isTenant && isAlexAvailable) {
    itemList.push({
      icon: SidebarALEXIcon,
      text: 'ALEX',
      aditionalClass: 'menu-hover-fill',
      target: '_blank',
      path: getAlexUrl(),
      onClick: () => {}
    });
  }
  itemList.push(
    {
      icon: SidebarH2HIcon,
      text: 'Help to Habit',
      path: '/v2/help-to-habit',
      onClick: () => {},
      enabled: !tenant || tenant?.has_help_to_habit
    },
    {
      icon: SidebarNotesIcon,
      text: 'Notes',
      path: '/v2/program/notes',
      onClick: () => {},
      enabled: !tenant || tenant?.has_behavior_notes
    },
    {
      icon: SidebarEventsIcon,
      path: 'https://admiredleadership.com/events/',
      text: 'Events',
      target: '_blank',
      onClick: () => {},
      enabled: !tenant || tenant?.has_events
    },
    {
      icon: SidebarResourcesIcon,
      text: 'Resources',
      path: null,
      onClick: () => {},
      enabled:
        !tenant ||
        tenant?.has_field_notes ||
        tenant?.has_al_direct ||
        tenant?.has_book_summaries,
      subList: resources.filter(({ enabled }) => enabled)
    },
    {
      icon: SidebarAdminIcon,
      text: 'Admin',
      path: '/v2/admin/user',
      onClick: () => {},
      role: 'admin'
    },
    {
      icon: SidebarAdminIcon,
      text: 'Old Admin',
      path: '/admin',
      onClick: () => {},
      role: 'admin'
    },
    // {
    //   icon: SupportIcon,
    //   text: 'Support',
    //   path: '/v2/contact-us',
    //   onClick: () => {},
    //   subList: [],
    // }
    // {
    //   icon: GiftIcon,
    //   text: 'Gift a Course',
    //   path: '/gift',
    //   onClick: () => {},
    //   subList: []
    // }
  );
  return itemList.filter(
    (item) => typeof item.enabled !== 'boolean' || item.enabled
  );
};

export const getHamburgerDropdownList = (
  isTenant,
  tenant,
  isSingleModule,
  isAlexAvailable
) => {
  const resources = [
    {
      path: 'https://admiredleadership.com/field-notes/archive/',
      text: 'Field Notes',
      enabled: !tenant || tenant?.has_field_notes
    },
    {
      path: '/v2/resources/playbook-direct',
      text: 'Playbook Direct',
      enabled: !tenant || tenant?.has_al_direct
    },
    {
      path: '/v2/resources/get-your-links',
      text: 'Get Podcast Links',
      enabled: true
    },
    {
      path: '/v2/resources/book-summaries',
      text: 'Book Summaries',
      enabled: !tenant || tenant?.has_book_summaries
    }
  ];

  const itemList = [
    {
      icon: ToolIcon,
      text: 'Admin Dashboard',
      path: '/v2/admin/user',
      onClick: () => {},
      subList: [],
      role: 'admin'
    }
  ];
  if (!isTenant) {
    itemList.push({
      icon: ToolIcon,
      text: 'Old Admin Dashboard',
      path: '/admin',
      onClick: () => {},
      subList: [],
      role: 'admin'
    });
  }
  itemList.push(
    {
      icon: AlLogoIcon,
      text: 'Dashboard',
      path: '/v2',
      onClick: () => {},
      subList: []
    },
    {
      icon: StarIcon,
      text: isSingleModule ? 'Behaviors' : 'Modules',
      path: '/v2/program',
      onClick: () => {},
      subList: []
    }
  );
  if (!isTenant && isAlexAvailable) {
    itemList.push({
      icon: AlexIcon,
      text: 'ALEX',
      aditionalClass: 'menu-hover-fill',
      target: '_blank',
      path: getAlexUrl(),
      onClick: () => {},
      subList: []
    });
  }
  itemList.push(
    {
      icon: IconHeart,
      text: 'Help to Habit',
      path: '/v2/help-to-habit',
      onClick: () => {},
      subList: [],
      enabled: !tenant || tenant?.has_help_to_habit
    },
    {
      icon: NotesIcon,
      text: 'Notes',
      path: '/v2/program/notes',
      onClick: () => {},
      subList: [],
      enabled: !tenant || tenant?.has_behavior_notes
    },
    {
      icon: EventsIcon,
      path: 'https://admiredleadership.com/events/',
      text: 'Events',
      onClick: () => {},
      subList: [],
      enabled: !tenant || tenant?.has_events
    },
    {
      icon: ResourcesIcon,
      text: 'Resources',
      path: null,
      onClick: () => {},
      enabled:
        !tenant ||
        tenant?.has_field_notes ||
        tenant?.has_al_direct ||
        tenant?.has_book_summaries,
      subList: resources.filter(({ enabled }) => enabled)
    },
    {
      icon: SupportIcon,
      text: 'Support',
      path: '/v2/contact-us',
      onClick: () => {},
      subList: []
    }
    // {
    //   icon: GiftIcon,
    //   text: 'Gift a Course',
    //   path: '/gift',
    //   onClick: () => {},
    //   subList: []
    // }
  );
  return itemList.filter(
    (item) => typeof item.enabled !== 'boolean' || item.enabled
  );
};

export const getUserDropdownList = (isTenant) => [
  {
    icon: UserIcon,
    text: 'View Profile Settings',
    path: '/v2/users/profile/manage-profile',
    onClick: () => {},
    subList: []
  },
  {
    icon: LogOutIcon,
    text: 'Sign Out',
    path: null,
    onClick: () => {
      fetch('/users/sign_out', {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'X-CSRF-Token': csrfToken()
        }
      }).then(() => {
        // window.location.href = ;
        window.location.href = isTenant
          ? '/users/sign_in'
          : `${window.ENV?.SSO_CLIENT ||
              'https://sso.admiredleadership.com'}/access`;
      });
    },
    subList: []
  }
];

export const getAdminMenu = (isTenant) => {
  const itemList = [
    {
      icon: UsersCircleIcon,
      text: 'Users',
      description: 'Add, update, or remove users and assign their access level',
      route: '/v2/admin/user',
      disabled: false
    }
  ];
  if (!isTenant) {
    itemList.push(
      {
        icon: Cohorts,
        text: 'Cohorts',
        description: 'Show cohorts on platform',
        route: '/v2/admin/cohorts',
        disabled: false
      },
      {
        icon: Cohorts,
        text: 'Companies',
        description: 'Show companies on platform',
        route: '/v2/admin/companies',
        disabled: false
      },
      {
        icon: BehaviorsIcon,
        text: 'Behaviors',
        description: 'Add, update, or remove behavior videos',
        route: '/v2/admin/manage-behaviors',
        disabled: false
      },
      {
        icon: Orders,
        text: 'Orders',
        description: 'Show orders on platform',
        route: '/v2/admin/orders',
        disabled: false
      },
      {
        icon: WebinarsIcon,
        text: 'Webinars',
        description: 'Show webinars on platform',
        route: '/v2/admin/webinars',
        disabled: false
      },
      {
        icon: ModulesIcon,
        text: 'Modules',
        description: 'Show modules on platform',
        route: '/v2/admin/modules',
        disabled: false
      },
      {
        icon: SmartPhoneIcon,
        text: 'Help to Habit',
        description: 'Add, update, or remove help to habit content',
        route: '/v2/admin/behaviors',
        disabled: false
      },
      {
        icon: SalesIcon,
        text: 'View Orders',
        description: 'View completed orders and gifts',
        route: '/admin/program/orders',
        disabled: true
      },
      {
        icon: Reports,
        text: 'Reports',
        description: 'Show reports usage platform',
        route: '/v2/admin/reports',
        disabled: false
      },
      {
        icon: CopyIcon,
        text: 'Tenants',
        description: 'Add, update or remove tenants',
        route: '/v2/admin/tenant',
        disabled: false
      },
      {
        icon: SupportIcon,
        text: 'System Banners',
        description: 'Manage maintenance alerts and system messages',
        route: '/v2/admin/system-banners',
        disabled: false
      },
      {
        icon: SalesIcon,
        text: 'Offline Conversions',
        description: 'Log enterprise-qualified conversations for GA4',
        route: '/v2/admin/offline-conversions',
        disabled: false
      },
      {
        icon: SupportIcon,
        text: 'Field Notes',
        description: 'Generate "Explore with ALEX" links and record the WordPress URL',
        route: '/v2/admin/field-notes',
        disabled: false
      }
    );
  }
  return itemList;
};

export const footerMenu = [
  { href: 'https://www.admiredleadership.com/about/', text: 'About Us' },
  { href: '/v2/contact-us', text: 'Get Support' },
  { href: '/v2/privacy-policy/', text: 'Privacy Policy' },
  { href: '/v2/user-agreement/', text: 'User Agreement' }
];

export const anchorSections = [
  'notes',
  'examples',
  'questions',
  'exercises',
  'behavior_maps',
  'gift'
];
// eslint-disable-next-line camelcase
export const h2h_faqs = [
  {
    question: 'What is Help to habit?',
    answer: <FAQ1 />
  },
  {
    question: 'How do i activate reminders for a behavior?',
    answer: <FAQ2 />
  },
  {
    question: 'Why can’t i add more reminders to my queue?',
    answer: <FAQ3 />
  }
];
